var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vbox flex stretch main-start cross-start",staticStyle:{"padding":"10px 20px"}},[_c('div',{staticClass:"spectrum-Typography"},[_c('MdView',{staticClass:"spectrum-Body3",attrs:{"article":_vm.article}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }